import { createDomain } from 'effector-root';

const domain = createDomain('Orders (Page)');

export const onPageStarted = domain.event();